import "./homeDoctor.scss";
import React, { useEffect, useState } from "react";
import { Box, Container, Alert, Typography, Link } from "@mui/material";
import { PageLayoutDoctor } from "../../../components/page/page-layout-doctor";
import WelcomeCard from "../../../components/doctor/welcome-card/WelcomeCard";
import axios from "axios";
import { API_BASE_URL } from "../../../constants/apiConstants";
import { Estados, EstadosNames } from "../../../constants/estados";
import { enqueueSnackbar } from "notistack";
import { Link as RouterLink } from "react-router-dom";
import { logoutDoctor } from "../../../utils";
import { getDecryptedDataFromSessionStorage } from "../../../utils";
import { SECRET_KEY } from "../../../constants/encriptKey";

const HomeDoctor = () => {
  const [userState, setUserState] = useState(null);
  const [alertInfo, setAlertInfo] = useState({});

  const fetchData = async () => {
    const data = getDecryptedDataFromSessionStorage(SECRET_KEY);
    const { idMedico, accessToken } = data;
    try {
      //const idMedico = localStorage.getItem("idMedico");
      const response = await axios.get(
        `${API_BASE_URL}Medicos/ConsultaMedico/${idMedico}`,
        {
          headers: {
            accept: "application/json",
            Authorization:`Bearer ${accessToken}`
          },
        }
      );

      if (response.data?.status === "Ok") {
        const { estado } = response.data.result;
        setUserState(estado);
        
        if (estado === EstadosNames.PENDIENTE_APROBACION) {
          setAlertInfo({
            state: Estados[estado],
            value: estado,
            type: "info",
          });
        }
        
        if (estado === EstadosNames.PENDIENTE_DOCUMENTACION) {
          setAlertInfo({
            state: Estados[estado],
            value: estado,
            type: "warning",
          });
        }
        
      } else if (response.data?.status === "Error") {
        logoutDoctor();
        window.location.href = "/"; 
      } else {
        enqueueSnackbar("Error en la respuesta del servidor", {
          variant: "error",
        });
      }
    } catch (error) {
      enqueueSnackbar("Error al cargar la información del médico", {
        variant: "error",
      });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <PageLayoutDoctor>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 2,
        }}
      >
        <Container maxWidth={false}>
          {alertInfo.state && userState === EstadosNames.PENDIENTE_APROBACION && (
            <Alert severity={alertInfo.type}>
              <Typography>
                Su cuenta no se encuentra aprobada. Por favor, envíe un mail a <strong>soporte@recetaonline.ar</strong> para más información.
              </Typography>
            </Alert>
          )}
          {alertInfo.state && userState === EstadosNames.PENDIENTE_DOCUMENTACION && (
            <Alert severity={alertInfo.type}>
              <Typography>
                Tiene documentación pendiente de envío. Por favor, complete el
                envío desde su perfil.
                <Link
                  component={RouterLink}
                  to="/my-info"
                  sx={{
                    textDecoration: "none",
                    color: "inherit",
                    fontWeight: "bold",
                    paddingLeft: 1
                  }}
                >
                  Ir a mi perfil
                </Link>
              </Typography>
            </Alert>
          )}
          <WelcomeCard
            title="Bienvenido al sistema de recetas electrónicas"
            subtitle="Su plataforma de gestión de recetas electrónicas"
          />
        </Container>
      </Box>
    </PageLayoutDoctor>
  );
};

export default HomeDoctor;
